import { create } from 'zustand';

interface DesktopCatalogueStore {
  isDesktopCatalogueOpen: boolean;
  toggleDesktopCatalogue: () => void;
}

export const useDesktopCatalogueStore = create<DesktopCatalogueStore>(set => ({
  isDesktopCatalogueOpen: false,
  toggleDesktopCatalogue: () =>
    set(state => ({ isDesktopCatalogueOpen: !state.isDesktopCatalogueOpen })),
}));
